import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'
import { isDesktop } from '../utils'

export default class ModDonate {
  constructor(el) {
    this.$el = $(el)

    this.mySwiper = null

    this.dom = {
      $swiper: this.$el.find('.swiper'),
      $swiperPagination: this.$el.find('.swiper-pagination'),
    }
  }

  init() {
    this.addSwiper()
    this.addEventListener()
  }

  addEventListener() {
    $(window).on('resize orientationchange', () => {
      this.handleDestroySwiper()
    })
  }

  addSwiper() {
    if (!isDesktop()) {
      this.mySwiper = new Swiper(this.dom.$swiper[0], {
        modules: [Pagination],
        speed: 500,
        slidesPerView: 1,
        pagination: {
          el: this.dom.$swiperPagination[0],
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
        },
      })
    }
  }

  handleDestroySwiper() {
    if (this.mySwiper) {
      this.mySwiper.destroy(true, true)
      this.mySwiper = null
    }
    this.addSwiper()
  }
}

const $modDonate = $('.mod-donate')
if ($modDonate.length) {
  $modDonate.each((_, element) => {
    new ModDonate(element).init()
  })
}
